// Import utility functions
import { FormatCurrency } from "global/utilities/ConvertCurrency";

// Import css
import "./EarningBreakdown.css";



const EarningBreakdown = ({ earningBreakdown }) => {

    // This stores the order breakdown
    const order = earningBreakdown?.order || {};

    // This stores the original currency
    const originalCurrency = order?.original_currency;

    // This stores the account currency
    const convertedCurrency = order?.converted_currency;

    // This stores the original order values
    const original = order?.original || order?.totals?.original || {};

    // This stores the fulfilment deduction
    const fulfilment = order?.totals?.deductions?.fulfilment || {};

    // This stores the fulfilment item lines
    const orderItems = fulfilment?.order_items || [];

    // This stores the final earning amount
    const earning = order?.totals?.earning || 0;

    // This stores the final earning amount
    const fees = original?.fees || 0;



    // Do not render without the breakdown currencies
    if (!originalCurrency || !convertedCurrency) { return null; }

    // This renders the earning breakdown
    return (

        // This is the main breakdown wrapper
        <div className="earning-breakdown">

            {/* This is the summary header */}
            <div className="earning-breakdown__header">

                {/* This is the title */}
                <h3 className="earning-breakdown__title">Earning breakdown</h3>

                {/* This explains the currency flow */}
                <p className="earning-breakdown__subtitle">
                    Order charges are calculated in {originalCurrency}, then your net amount is converted to {convertedCurrency} before fulfilment is deducted.
                </p>

            </div>

            {/* This shows the main calculation steps */}
            <div className="earning-breakdown__steps">

                {/* This shows the gross order value */}
                <div className="earning-breakdown__step earning-breakdown__step--positive">

                    <span className="earning-breakdown__label">Order value</span>

                    <strong className="earning-breakdown__value">
                        {FormatCurrency(originalCurrency, original?.gross || 0, false)}
                    </strong>

                </div>

                {/* This shows taxes */}
                <div className="earning-breakdown__step earning-breakdown__step--negative">

                    <span className="earning-breakdown__label">Taxes collected</span>

                    <strong className="earning-breakdown__value">
                        -{FormatCurrency(originalCurrency, original?.taxes?.total || 0, false)}
                    </strong>

                </div>



                {/* This shows platform and payment fees */}
                <div className="earning-breakdown__fees">

                    <div className="earning-breakdown__step earning-breakdown__step--negative earning-breakdown__step--breakdown">

                        <span className="earning-breakdown__label">Platform & payment fees</span>

                        <strong className="earning-breakdown__value">
                            -{FormatCurrency(originalCurrency, original?.fees?.total || 0, false)}
                        </strong>

                    </div>

                    <div className="earning-breakdown__items">

                        <div>

                            <div className="earning-breakdown__item">

                                <span className="earning-breakdown__item-title">Platform Fee</span>

                                <span className="earning-breakdown__value">
                                    {FormatCurrency(originalCurrency, fees?.platform?.total || 0, false)}
                                </span>

                            </div>

                            <div className="earning-breakdown__item">

                                <span className="earning-breakdown__item-title">Payment Fee</span>

                                <span className="earning-breakdown__value">
                                    {FormatCurrency(originalCurrency, fees?.payment?.total || 0, false)}
                                </span>

                            </div>

                        </div>

                    </div>

                </div>


                {/* This shows converted net if the currencies don't match */}
                {convertedCurrency !== originalCurrency &&

                    <div className="earning-breakdown__step earning-breakdown__step--converted">

                        <span className="earning-breakdown__label">
                            Converted {FormatCurrency(originalCurrency, original?.net || 0, false)} to {convertedCurrency} at exchange rate {order?.exchange_rate}
                        </span>

                        <strong className="earning-breakdown__value">
                            {FormatCurrency(convertedCurrency, order?.converted?.net || 0, false)}
                        </strong>

                    </div>

                }

                {/* This shows fulfilment deductions */}
                <div className="earning-breakdown__step earning-breakdown__step--negative earning-breakdown__step--breakdown">

                    <span className="earning-breakdown__label">Fulfilment costs</span>

                    <strong className="earning-breakdown__value">
                        -{FormatCurrency(convertedCurrency, fulfilment?.total || 0, false)}
                    </strong>

                </div>

            </div>

            {/* This shows fulfilment line details */}
            <div className="earning-breakdown__items">

                {orderItems.map((item) => (

                    <div key={item.order_item_id} className="earning-breakdown__item">

                        <div className="earning-breakdown__item-main">

                            <strong className="earning-breakdown__item-title">{item.title}</strong>

                            <span className="earning-breakdown__item-meta">
                                {item.sku} · Qty {item.quantity}
                            </span>

                        </div>

                        <div className="earning-breakdown__item-costs">

                            <span>Base {FormatCurrency(convertedCurrency, item.line_base || 0, false)}</span>

                            <span>Print {FormatCurrency(convertedCurrency, item.line_print || 0, false)}</span>

                            <strong>{FormatCurrency(convertedCurrency, item.line_total || 0, false)}</strong>

                        </div>

                    </div>

                ))}

                <div className="earning-breakdown__item earning-breakdown__item--shipping">

                    <span className="earning-breakdown__label">Fulfilment Shipping</span>

                    <strong className="earning-breakdown__value">
                        {FormatCurrency(convertedCurrency, fulfilment?.shipping || 0, false)}
                    </strong>

                </div>

            </div>

            {/* This shows the final earning 
            <div className="earning-breakdown__total">

                <span className="earning-breakdown__total-label">Your earning</span>

                <strong className="earning-breakdown__total-value">
                    {FormatCurrency(convertedCurrency, earning || 0, false)}
                </strong>

            </div>
            */}

            {/* This shows the final balance addition */}
            <div className="earning-breakdown__total">

                {/* This is the total label */}
                <span className="earning-breakdown__total-label">
                    Added to your balance
                </span>

                {/* This is the final balance deduction */}
                <strong className="earning-breakdown__total-value">
                    {FormatCurrency(convertedCurrency, earning || 0, false)}
                </strong>

            </div>

        </div>

    );

};

export default EarningBreakdown;